define('controllers/myservices/huaweiid/huaweiid-detail.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('huaweiidDetailCtrl', ['$scope', '$q', '$filter', '$stateParams', '$state',
        'OpenApp',
        'OpenGW', 'auiDialog', 'payService', 'getServiceList',
        function ($scope, $q, $filter, $stateParams, $state,
                  OpenApp,
                  OpenGW, auiDialog, payService, getServiceList) {

            var serviceItem = $stateParams.serviceItem;
            var prodID = $stateParams.prodID;
            var openStateFilter = mainCons.appConstant.openStateFilter;
            $scope.backToList = backToList;
            $scope.submitSer = submitSer;
            $scope.delete = deleteSer;
            var Model = $scope.Model = {
                defaultList: [],
                pmsSdkLink: sysUrlCfg.documentHref.pmsSdkUrl,
                product: {}
            };

            init();

            function init() {

                //获取指纹，安全URL
                var paramsQueryAppName = {
                    request: {
                        appID: prodID
                    }
                };

                OpenApp.getAppDetail(paramsQueryAppName, true).then(function (data) {
                    if (data && data.resultCode == 0) {
                        Model.currAppDetail = data.appInfo;
                        if (data.appInfo && data.appInfo.languages[0] && data.appInfo.languages[0].appIcon) {
                            //如果当前存在APPICon 则展示
                            Model.appIcon = data.appInfo.languages[0].appIcon;
                        }
                        var gwParams = {
                            appId: prodID,
                            attrs: ["secret"]
                        }
                        payService.getFingerPrintInfo(data.appInfo, Model);
                        getsecreUrl(data.appInfo, Model);
                        OpenGW.getAppInfo(gwParams).then(function (data) {
                            Model.appsecret = data.secret;
                        });

                        getServiceDetail(data.appInfo);
                    }
                });
                // 获取状态、回调地址
                var params = {
                    request: {
                        prodID: [prodID]
                    }
                };
                OpenApp.getProductByID(params).then(function (data) {
                    if (data) {
                        if (data.productList[0]) {
                            $scope.prodType = Model.prodType = data.productList[0].prodType;
                            Model.product = data.productList[0];
                            Model.freeInstallType = data.productList[0].freeInstallType;
                            Model.prodName = data.productList[0].prodName;
                            Model.isShowPms = Model.prodType == 1;
                            angular.forEach(data.productList[0].serviceList, function (GService) {
                                if (GService.serviceItem == 32) {
                                    Model.serviceStatus = $filter('auiMapWithDefault')(GService.openState, openStateFilter, 0);
                                    Model.product.serviceSingle = GService;

                                }
                            });
                        }
                    } else {
                        auiDialog.fail("查询产品信息失败。");
                    }
                });
            }

            //修改
            function submitSer(product) {
                product.isUpdate = true;
                $state.go('rollout.selPkg', {serviceItem: serviceItem, product: product});
            }

            //删除
            function deleteSer(prod) {
                getServiceList.deleteAll(prod).then(function (res) {
                    if (res && res.resultCode == 0) {
                        auiDialog.successAndMark('删除成功', function () {
                            $state.go('myServiceList', {serviceItem: '32'}, {reload: true});
                        }, {isOnShelf: '4'});
                    }
                });
            }

            // 获取服务提交时间
            getServiceList.getWorkOrdersCreateTime(serviceItem, prodID).then(function (res) {
                Model.createTime = res;
            });

            function getServiceDetail(appInfo) {
                //获取接入方式
                var queryParam = {
                    request: {
                        prodID: prodID,
                        prodType: appInfo.prodType,
                    }
                };
                Model.bundleId = appInfo.bundleId ? appInfo.bundleId : null;
                Model.testBundleId = appInfo.testBundleId ? appInfo.testBundleId : null;
                //查询类别prodID，parentType
                OpenApp.getServiceList(queryParam).then(function (res) {
                    if (res.resultCode == 0) {

                        for (var i in res.serviceList) {
                            if (res.serviceList[i].serviceItem == serviceItem) {
                                if (angular.fromJson(res.serviceList[i].serviceAttrs) && angular.fromJson(res.serviceList[i].serviceAttrs).accessMode) {
                                    Model.accessMode = angular.fromJson(res.serviceList[i].serviceAttrs).accessMode;
                                    Model.accessModesdk = Model.accessMode.indexOf(1) != -1;
                                    Model.accessModejssdk = Model.accessMode.indexOf(2) != -1;
                                }
                            }
                        }
                    } else {
                        auiDialog.fail('getServiceList调用失败');
                    }
                }).catch(function (data) {
                });
            }

            function contains(arr, obj) {
                if (arr != undefined) {
                    var i = arr.length;
                    while (i--) {
                        if (arr[i] == obj) {
                            return true;
                        }
                    }
                }
                return false;
            }

            //控制选中未选中的样式
            $scope.showAdaptClass = function (adapt) {
                if (adapt) {
                    return "已启用";
                } else {
                    return "未启用";
                }
            };

            //获取安全URL
            function getsecreUrl(appInfo, targetObj) {
                if (appInfo && appInfo.appAttrs) {
                    var attrs = angular.fromJson(appInfo.appAttrs);
                    var prodType = appInfo.prodType;
                    if (AUI.BaseJSUtil.existy(attrs.secureUrlList)) {
                        //免安装应用-rpk sha256指纹比较特别
                        targetObj.secureUrlList = attrs.secureUrlList;
                    }
                    if (AUI.BaseJSUtil.existy(attrs.oauthRedirectUri)) {
                        targetObj.callbackUrl = attrs.oauthRedirectUri;
                        targetObj.callbackUrlList = [attrs.oauthRedirectUri];
                    } else {
                        targetObj.callbackUrlList = [];
                    }
                    if (AUI.BaseJSUtil.existy(attrs.oauthRedirectUriExtra)) {
                        targetObj.callbackUrlList = targetObj.callbackUrlList.concat(angular.fromJson(attrs.oauthRedirectUriExtra));
                    }
                }
            }

            function backToList() {
                $scope.queryList();
                $state.go('myServiceList', {serviceItem: '32'});
            }

        }]);
});

